let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d0Ze0")).then(() => parcelRequire('g5gWI'));